import { LabelBinding, ResponseDataOfGetOverviewResponse } from '@monorepo-types/dc/smartthermostat';

import { request } from '../../client';
import type { ApiRequestConfig } from '../../client/types';

type GetOverview = { businessUnit: string; label: LabelBinding; customerId: number; accountId: number };
/**
 *
 *
 * @returns ResponseDataOfGetOverviewResponse OK
 */
export function getOverview(
  { businessUnit, label, customerId, accountId }: GetOverview,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseDataOfGetOverviewResponse> {
  return request(
    {
      method: 'GET',
      path: `/v1/smartthermostat/support/${businessUnit}/${label}/customers/${customerId}/accounts/${accountId}/overview`,
      errors: { 400: 'Bad Request', 403: 'Forbidden', 404: 'Not Found', 500: 'Internal Server Error' },
    },
    requestConfig,
  );
}
